//#region redux
import { useDispatch } from "react-redux";
import { surveyForwarded } from "store/actions/surveyActions";
//#endregion
//#region types
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { IconDefinitionConstants } from "utils/constants";
import { MoreActionMenuItem } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
//#endregion
//#endregion
import { useSurveyService } from "serviceHooks";
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

function useSurveyForwardAction(id: string, markAsDone: (id: string) => void) {
  const surveyService = useSurveyService();
  const dispatch = useDispatch();

  const onForwardUserSelect = (item: SelectionItem | SelectionItem[]) => {
    const selectedItem = item as SelectionItem;
    return surveyService.sendToPerson(id, { personId: selectedItem.id as number });
  };

  const getForwardUserSuggestions = () => {
    return UtilsHelper.convertToResultItem(surveyService.getSuggestedSurveyPersons());
  };

  const searchForwardUsers = (searchText: string) => {
    return UtilsHelper.convertToResultItem(surveyService.getSurveyPersons(searchText));
  };

  const onForwardSuccess = () => {
    dispatch(surveyForwarded(id));
    markAsDone(id);
  };

  const forwardActionDialog: DialogProps = {
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ForwardToColleague),
    subTitle: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ForwardToWhom),
    titleIcon: IconDefinitionConstants.WForward,
    dialogType: DialogEnums.DialogType.Selection,
    children: {
      getSuggestions: getForwardUserSuggestions,
      search: searchForwardUsers,
      handleSubmit: onForwardUserSelect,
      submitSuccessMessage: LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Survey.ForwardSuccessMessage
      ),
    },
    maxWidth: "sm",
    onSubmit: onForwardSuccess,
  };

  const forwardAction: MoreActionMenuItem = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Forward),
    icon: IconDefinitionConstants.WForward,
    actionDialog: forwardActionDialog,
    onActionSuccess: onForwardSuccess,
  };

  return { forwardAction, forwardActionDialog };
}

export default useSurveyForwardAction;
